import groupExcelService from "@/services/Finance_Kids_V2/GroupExcelService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
    methods:{
        // Hiển thị trên app phụ huynh cho  1 or nhều học sinh cho nhóm
        showListOrderForApp(idKidList,dataSearch,showListForApp) {
            if (idKidList.split(",").map(Number).indexOf(0) === 0) {
                NotifyMessage.leftCornerNotificationWarning("Chưa có học sinh nào được chọn")
            } else {
                this.$confirm(
                    `
            ⚠️ <strong>Bạn có chắc chắn muốn hiện các phiếu thu được chọn không?</strong><br><br>
            Vui lòng kiểm tra kỹ thông tin phiếu thu trước khi thực hiện:<br>
            👉 Bạn muốn tiếp tục?
            `,
                    "Xác nhận thay đổi trạng thái phiếu thu",
                    {
                        confirmButtonText: "Có, Tiếp tục",
                        cancelButtonText: "Không",
                        type: "warning",
                        dangerouslyUseHTMLString: true,
                        closeOnClickModal: false,
                        distinguishCancelAndClose: true,
                    }
                ).then(async () => {
                    showListForApp.date = this.$funcCommon.formatMY(dataSearch.createdYear, dataSearch.month);
                    showListForApp.idKidList = idKidList.split(",").map(Number);
                    showListForApp.collectionTurn = dataSearch.collectionTurn;
                    showListForApp.idGroup=dataSearch.idGroup
                    groupExcelService
                        .showListOrderAppForGroup(showListForApp)
                        .then(() => {
                            this.$message({
                                message: "Hiển thị thành công",
                                type: "success",
                            });
                            this.$store.dispatch(
                                "groupExcelModule/init_kids_data",
                                dataSearch
                            );
                        })
                        .catch((err) => {
                            this.$message({
                                message: err.response.data.message,
                                type: "error",
                            });
                        });
                });
            }
        },

        // Ẩn hiển thị trên app phụ huynh cho  1 or nhều học sinh cho nhóm
        hiddenListOrderForApp(idKidList,dataSearch,showListForApp) {
            if (idKidList.split(",").map(Number).indexOf(0) === 0) {
                NotifyMessage.leftCornerNotificationWarning("Chưa có học sinh nào được chọn")
            } else {
                this.$confirm(
                    `
            ⚠️ <strong>Bạn có chắc chắn muốn hiện các hóa đơn được chọn không?</strong><br><br>
            Vui lòng kiểm tra kỹ thông tin hóa đơn trước khi thực hiện:<br>
            👉 Bạn muốn tiếp tục?
            `,
                    "Xác nhận thay đổi trạng thái hóa đơn",
                    {
                        confirmButtonText: "Có, Tiếp tục",
                        cancelButtonText: "Không",
                        type: "warning",
                        dangerouslyUseHTMLString: true,
                        closeOnClickModal: false,
                        distinguishCancelAndClose: true,
                    }
                ).then(async () => {
                    showListForApp.date = this.$funcCommon.formatMY(dataSearch.createdYear, dataSearch.month);
                    showListForApp.idKidList = idKidList.split(",").map(Number);
                    showListForApp.idGroup=dataSearch.idGroup
                    showListForApp.collectionTurn = dataSearch.collectionTurn;

                    groupExcelService
                        .hiddenListOrderForGroupApp(showListForApp)
                        .then(() => {
                            this.$message({
                                message: "Bỏ hiển thị thành công",
                                type: "success",
                            });
                            this.$store.dispatch(
                                "groupExcelModule/init_kids_data",
                                dataSearch
                            );
                        })
                        .catch((err) => {
                            this.$message({
                                message: err.response.data.message,
                                type: "error",
                            });
                        });
                });

            }
        },
    }
}